import { default as EasyQRCode } from 'easyqrcodejs'

export type QRCodeOptions = {
  code: string
  qrCodeElement: HTMLElement
}

export class QRCode {
  static createQRCode({ code, qrCodeElement }: QRCodeOptions) {
    if (!qrCodeElement) {
      throw new Error('Cannot find QRCode element')
    }

    qrCodeElement.innerHTML = ''

    new EasyQRCode(qrCodeElement, {
      title: code,
      titleFont: 'bold 14px Deacon Test',
      titleHeight: 30,
      titleTop: 10,
      logo: '/assets/logo-dark.svg',
      text: code,
      quietZone: 20,
      onRenderingEnd(qrCodeOptions: any) {
        const qrCode = qrCodeElement.querySelector('canvas')

        console.log(qrCodeOptions)

        if (!qrCode) {
          throw new Error('Cannot find QRCode canvas element')
        }

        const dataUrl = qrCode.toDataURL('image/jpeg', 1.0)

        qrCodeElement.setAttribute('src', dataUrl)
      },
    })
  }
}
